<template>
    <div id="mainer" class="main" :style="mainer==3?'padding-top: 60px':''">
        <div class="aboutimg"><img v-lazy="src" :style="mainer==3?'width: 100%':''"></div>
        <div class="aboutC" :style="mainer==3?'width: 100%':''">
          <div class="aboutButton">
            <button :class="classz" @click="translation('中文')">{{mainer==3?'中':'中文'}}</button>
            <button :class="classe" @click="translation('Englist')">{{mainer==3?'En':'English'}}</button></div>
          <h3><img src="../../static/assets/logo@1x.png">{{h3}}</h3>
          <p class="explanation">{{p}}</p>
          <ul class="web">
            <li class="aboutContent clear" v-for="about in aboutList" :key="about.title" :style="marginLeft" >
              <img :src="about.src">
              <h4>{{about.title}}</h4>
              <p :class="fontsize">{{about.content}}</p>
            </li>
          </ul>
          <ul class="mobile">
            <li class="aboutContent clear" v-for="about in aboutList" :key="about.title" :style="marginLeft" >
              <img :src="about.src">
              <h4>{{about.title}}</h4>
              <p :class="fontsize">{{about.content}}</p>
            </li>
          </ul>
        </div>
    </div>
</template>
<script>
  export default {
      props:['mainer'],
      name: "mainer",
      data(){
          return{
              src:require('../../static/assets/guanyuwomen@1x.png'),
              h3:"天下医生会员管家",
              p:'天下医生会员管家，全称为：会员与智能终端数字化管理系统，是天下医生智慧数字医疗整体解决方案构成之一，为成都天下医森数字科技有限公司开发并提供给合作终端伙伴〔B端机构，如：药房、医院、诊所、体检、养老院等〕使用。',
              aboutList:[{
                  src:require('../../static/assets/access@1x.png'),
                  title:'易操作',
                  content:'会员管家"装”在电脑或平板里,即装即用'
              },{
                  src:require('../../static/assets/database@1x.png'),
                  title:'高性能',
                  content:'一体化的“硬件-数据-服务”深度聚合、交互应用架构，助力“医药健康品新零售与医疗健康服务”能快捷实现数字化管理与运维，让日常业务处理变得更加简捷、高效、高质'
              },{
                  src:require('../../static/assets/worldwide@1x.png'),
                  title:'多功能',
                  content:'具有“硬件管理、 多人多指标批量移动检测、数据传输与专属云存储、医生解读服务、报告打印”等多种功能'
              },{
                  src:require('../../static/assets/cloud-computing@1x.png'),
                  title:'专属云',
                  content:'配置华为专属云，为终端提供强大、安全的计算与存储能力'
              }],
              classz:'aboutActive',
              classe:'',
              fontsize:'',
              clist:[{
                  src:require('../../static/assets/access@1x.png'),
                  title:'易操作',
                  content:'会员管家"装”在电脑或平板里,即装即用'
              },{
                  src:require('../../static/assets/database@1x.png'),
                  title:'高性能',
                  content:'一体化的“硬件-数据-服务”深度聚合、交互应用架构，助力“医药健康品新零售与医疗健康服务”能快捷实现数字化管理与运维，让日常业务处理变得更加简捷、高效、高质'
              },{
                  src:require('../../static/assets/worldwide@1x.png'),
                  title:'多功能',
                  content:'具有“硬件管理、 多人多指标批量移动检测、数据传输与专属云存储、医生解读服务、报告打印”等多种功能'
              },{
                  src:require('../../static/assets/cloud-computing@1x.png'),
                  title:'专属云',
                  content:'配置华为专属云，为终端提供强大、安全的计算与存储能力'
              }],
              elist:[{
                  src:require('../../static/assets/access@1x.png'),
                  title:'Easy operation',
                  content:'Member housekeeper "installs" in the computer or tablet, ready to use'
              },{
                  src:require('../../static/assets/database@1x.png'),
                  title:'High-performance',
                  content:'Integrated "hardware-data-service" deep aggregation and interactive application architecture, enabling "medical health products, new retail and medical health services" to quickly realize digital management and operation and maintenance, making daily business processing easier High efficiency and high quality'
              },{
                  src:require('../../static/assets/worldwide@1x.png'),
                  title:'Multi-function',
                  content:'has many functions such as “hardware management, multi-person multi-indicator batch mobile detection, data transmission and Dedicated Cloud storage, doctor interpretation service, report printing”'
              },{
                  src:require('../../static/assets/cloud-computing@1x.png'),
                  title:'Private Cloud',
                  content:'Configure Huawei\'s Dedicated Cloud to provide powerful and secure computing and storage capabilities for terminals'
              }],
              marginLeft:'',
              screenWeight:document.body.clientWidth,
          }
      },
      methods:{
          translation(val){
              if(val=='中文'){
                  this.classz='aboutActive'
                  this.classe=''
                  this.h3='天下医生会员管家'
                  this.p='天下医生会员管家，全称为：会员与智能终端数字化管理系统，是天下医生智慧数字医疗整体解决方案构成之一，为成都天下医森数字科技有限公司开发并提供给合作终端伙伴〔B端机构，如：药房、医院、诊所、体检、养老院等〕使用。'
                  this.aboutList=this.clist
                  this.fontsize=''
              }else {
                  this.classe='aboutActive'
                  this.classz=''
                  this.h3='TIANXIA120 MEMBER BUTLER'
                  this.p='The tianxia120 member butler, full name: Member and Intelligent Terminal Digital Management System, is one of the tianxia120\' intelligent digital medical solutions, developed for Chengdu Tianxia120 Digital Technology Co., Ltd. and provided to cooperative terminal partners (B-end institutions, such as: pharmacies, hospitals, clinics, medical examinations, nursing homes, etc.) .'
                  this.aboutList=this.elist
                  this.fontsize='fontsize'
              }
          }
      },
  }
</script>

<style lang='less'>
  .clear::after{
      content: '';
      clear: both;
      display:block;
      height:0;
  }
@media only screen and (max-width: 1920px){
  #mainer{
    padding-top: 100px;
    background:rgba(20,175,156,0.05);
    .aboutimg{
      margin: 0 auto;
      img{
        width: 75%;
      }
    }
    .aboutC{
      width: 75%;
      margin: 0 auto;
      position: relative;
      background: #fff;
      .aboutButton{
        position: absolute;
        top: 10px;
        right: 10px;
        button{
          width: 72px;
          line-height: 25px;
          font-size: 18px;
          border: none;
          outline: none;
          color: #54C4C5;
          background: #fff;
          margin-left: 10px;
          border: 1px solid rgba(84, 196, 197, 0.1);
        }
      }
      .aboutButton .aboutActive{
        color: #fff;
        background: linear-gradient(90deg,rgba(83,187,168,1) 0%,rgba(0,161,188,1) 58%,rgba(0,128,201,1) 100%);
      }
      h3{
        font-size: 36px;
        font-weight:500;
        color:#333333;
        line-height: 100px;
        padding-top: 50px;
        img{
          width: 60px;
          height: 52px;
          margin-right: 20px;
          vertical-align: middle;
        }
      }
      .explanation{
        padding: 0 120px;
        margin: 0 auto;
        color: #333333;
        font-size: 18px;
      }
      .web{
        display: block;
        padding: 0 20px 80px;
        margin: 60px auto 0;
        display: flex;
        justify-content: space-around;
        align-content: center;
        li{
          width: 212px;
          height: 380px;
          img{
            width: 68px;
            height: 60px;
            margin: 40px auto 25px;
          }
          h4{
            color: #333333;
            font-size:24px;
            font-weight:500;
            margin-bottom: 10px;
          }
          p{
            padding: 0 15px;
            color: #666666;
            font-size:18px;
            font-weight:400;
          }
          p.fontsize{
            font-size: 14px;
          }
        }
        li:last-of-type{
          margin-right: 0px;
        }
        li:hover{
          box-shadow:0px 2px 44px 0px rgba(84,196,197,0.2);
          border-radius:8px;
        }
      }
      .mobile{
        display: none;
      }
    }
  }
}
@media only screen and (max-width: 1400px){
  #mainer{
    padding-top: 80px;
    .aboutC{
      width: 75%;
      h3{
        font-size: 28px;
        padding-top: 40px;
        img{
          width: 50px;
          height: 42px;
          margin-right: 10px;
        }
      }
      .explanation{
        padding: 0 40px;
        font-size: 16px;
      }
      .web{
        padding: 0 90px 80px;
        margin: 40px auto 0;
        flex-wrap: wrap;
        li{
          width: 286px;
          height: 380px;
          img{
            width: 58px;
            height: 50px;
            margin: 40px auto 25px;
          }
          h4{
            font-size:20px;
            margin-bottom: 10px;
          }
          p{
            padding: 0 20px;
            font-size:16px;
          }
          p.fontsize{
            font-size: 14px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 992px){
  #mainer .aboutC h3{
    font-size: 22px;
  }
  #mainer .aboutC h3 img{
    width: 40px;
    height: 32px;
  }
}
@media only screen and (max-width: 768px){
  #mainer .aboutC h3{
    font-size: 18px;
  }
  #mainer .aboutC h3 img{
    width: 30px;
    height: 26px;
    margin-right: 5px;
    margin-top: -5px;
  }
  #mainer .aboutC .explanation{
    font-size: 14px;
    padding: 0 20px;
  }
  #mainer .aboutC .web{
    padding: 0 30px 60px;
    li{
      height: 350px;
      img{
        width: 48px;
        height: 40px;
      }
      h4{
        font-size: 16px;
      }
      p{
        font-size: 14px;
      }
    }
  }
}
@media only screen and (max-width: 600px){
  #mainer{
    background: #fff;
  }
  #mainer .aboutC{
    .aboutButton button{
      width: 25px;
      font-size: 14px;
      margin-left: 5px;
    }
    .web{
      display: none;
    }
    .mobile{
      display: block;
      /*width: 270px;*/
      margin: 35px 20px 0;
      li{
        box-shadow:0px 2px 44px 0px rgba(84,196,197,0.1);
        margin-bottom: 40px;
        img{
          margin: 30px auto;
        }
        h4{
          margin-bottom: 16px;
        }
        p{
          text-align: left;
          color: #333;
          padding: 0 20px;
          padding-bottom: 65px;
        }
      }
      li:last-of-type p{
        padding-bottom: 30px;
      }
    }
  }

}



</style>




// WEBPACK FOOTER //
// src/components/mainer.vue